import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import type { Crumb } from '../../types/content';
export function Breadcrumbs({
  items
}: {
  items: Crumb[];
}) {
  return <nav aria-label="Breadcrumb" data-id="element-541" data-mp="fnmcr2rgbapo">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-steel-300" data-id="element-542" data-mp="fqs12fs9a8kc">
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <li key={item.label} className="flex items-center gap-1.5" data-id="element-543" data-mp="5xjhsx0rrmop" data-mpi={index}>
              {item.to && !isLast ? <Link to={item.to} className="transition-colors duration-150 hover:text-white" data-id="element-544" data-mp="arfg60ky3bke">
                  {item.label}
                </Link> : <span aria-current={isLast ? 'page' : undefined} className={isLast ? 'text-white' : ''} data-id="element-545" data-mp="10azmwfmfing">
                  {item.label}
                </span>}
              {!isLast && <ChevronRightIcon className="h-3.5 w-3.5 text-steel-400" aria-hidden="true" data-id="element-546" data-mp="3o360jm9cs0xc" />}
            </li>;
      })}
      </ol>
    </nav>;
}